import { Observable, of } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../../config';
import { VoucherDemoModeService } from '../../vouchers/demo/voucher-demo-mode.service';
import { buildDemoSalesSummary } from '../../vouchers/demo/voucher-demo-dashboard';
import * as i0 from "@angular/core";
import * as i1 from "../../config/config.service";
import * as i2 from "../../vouchers/demo/voucher-demo-mode.service";
var HahaHttpService = /** @class */ (function () {
    function HahaHttpService(configService, demoMode) {
        this.configService = configService;
        this.demoMode = demoMode;
        this.apiName = this.configService.get('host');
    }
    HahaHttpService.prototype.explore = function (payload) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/haha/explore';
            var myInit = {
                response: false,
                body: payload
            };
            API.post(_this.apiName, path, myInit)
                .then(function (response) {
                observer.next(response);
                observer.complete();
            })
                .catch(function (error) { return observer.error(error); });
        });
    };
    HahaHttpService.prototype.listDevices = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/haha/devices';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit)
                .then(function (response) {
                observer.next(response);
                observer.complete();
            })
                .catch(function (error) { return observer.error(error); });
        });
    };
    HahaHttpService.prototype.getSalesSummary = function (query) {
        var _this = this;
        if (this.demoMode.isEnabled()) {
            return of({
                status: 200,
                message: 'ok',
                data: buildDemoSalesSummary(query)
            });
        }
        return new Observable(function (observer) {
            var path = '/dashboard/haha/sales-summary';
            var queryStringParameters = {
                start_time: query.start_time,
                end_time: query.end_time
            };
            if (query.campus_id !== null && query.campus_id !== undefined) {
                queryStringParameters.campus_id = String(query.campus_id);
            }
            else if (query.client_id !== null && query.client_id !== undefined) {
                queryStringParameters.client_id = String(query.client_id);
            }
            var myInit = {
                response: false,
                queryStringParameters: queryStringParameters
            };
            API.get(_this.apiName, path, myInit)
                .then(function (response) {
                observer.next(response);
                observer.complete();
            })
                .catch(function (error) { return observer.error(error); });
        });
    };
    HahaHttpService.prototype.getDevice = function (hahaMarketId) {
        var _this = this;
        return this.request(function () { return API.get(_this.apiName, "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId), {
            response: false
        }); });
    };
    HahaHttpService.prototype.getDeviceSales = function (hahaMarketId) {
        var _this = this;
        return this.request(function () { return API.get(_this.apiName, "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId) + "/sales", {
            response: false
        }); });
    };
    HahaHttpService.prototype.getDeviceStatusHistory = function (hahaMarketId) {
        var _this = this;
        return this.request(function () { return API.get(_this.apiName, "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId) + "/status-history", {
            response: false
        }); });
    };
    // Slow on a cold cache: Haha's restock list takes 5-15 seconds.
    HahaHttpService.prototype.getDeviceStockChanges = function (hahaMarketId) {
        var _this = this;
        return this.request(function () { return API.get(_this.apiName, "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId) + "/restocks", {
            response: false
        }); });
    };
    HahaHttpService.prototype.pairDevice = function (hahaMarketId, machineId) {
        var _this = this;
        return this.request(function () { return API.put(_this.apiName, "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId) + "/pairing", {
            response: false,
            body: { machine_id: machineId }
        }); });
    };
    HahaHttpService.prototype.unpairDevice = function (hahaMarketId) {
        var _this = this;
        return this.request(function () { return API.del(_this.apiName, "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId) + "/pairing", {
            response: false
        }); });
    };
    HahaHttpService.prototype.getMachinePairedDevice = function (machineId) {
        var _this = this;
        return this.request(function () { return API.get(_this.apiName, "/dashboard/haha/machines/" + encodeURIComponent(machineId) + "/paired-device", {
            response: false
        }); });
    };
    HahaHttpService.prototype.request = function (call) {
        return new Observable(function (observer) {
            call()
                .then(function (response) {
                observer.next(response);
                observer.complete();
            })
                .catch(function (error) { return observer.error(error); });
        });
    };
    HahaHttpService.prototype.assignDevice = function (hahaMarketId, payload) {
        var _this = this;
        return new Observable(function (observer) {
            var path = "/dashboard/haha/devices/" + encodeURIComponent(hahaMarketId);
            var myInit = {
                response: false,
                body: payload
            };
            API.put(_this.apiName, path, myInit)
                .then(function (response) {
                observer.next(response);
                observer.complete();
            })
                .catch(function (error) { return observer.error(error); });
        });
    };
    HahaHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HahaHttpService_Factory() { return new HahaHttpService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.VoucherDemoModeService)); }, token: HahaHttpService, providedIn: "root" });
    return HahaHttpService;
}());
export { HahaHttpService };
